import { useContext } from "react";
import { Select, SelectProps } from "antd";
import { useTranslation } from "react-i18next";

import SText from "@/styles/SText";
import { DictContext } from "@/layout/context/DictContext";
import { CellSelectWrap } from "./style";

interface SCurrencyProps extends SelectProps {
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

const CurrencySelect = ({
  value,
  onChange,
  readOnly,
}: SCurrencyProps) => {
  const { t } = useTranslation();
  const { currencys } = useContext(DictContext);

  if (readOnly) {
    return <SText text={currencys.find(item => item.key === value)?.desc ?? ''} />;
  }

  return (
    <CellSelectWrap>
      <Select
        value={value}
        disabled={readOnly}
        onChange={onChange}
        showSearch
        filterOption={(input, option) =>
          (option?.desc ?? "").toLowerCase().includes(input.toLowerCase())
        }
        style={{ width: "100%" }}
        placeholder={t("components.plCurrency")}
        options={currencys}
        fieldNames={{ label: "desc", value: "key" }}
        labelRender={(info) => (
          <SText
            text={info.label as string}
            style={{ width: readOnly ? "100%" : 80 }}
          />
        )}
        popupMatchSelectWidth={false}
      />
    </CellSelectWrap>
  );
};

export default CurrencySelect;
